import { render, staticRenderFns } from "./GigJobCard.htm?vue&type=template&id=a86ecda8&scoped=true&"
import script from "./GigJobCard.ts?vue&type=script&lang=js&"
export * from "./GigJobCard.ts?vue&type=script&lang=js&"
import style0 from "./GigJobCard.scss?vue&type=style&index=0&id=a86ecda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86ecda8",
  null
  
)

export default component.exports